import React, { useCallback, useEffect, useState, useContext } from 'react';
import OptionsBoxRadio from '@ui/options-box-radio';
import PageActionContext from '@stores/page-action-context';

const FormConfirmationChoice = ({ data }) => {
    const [option, setOption] = useState(null);
    const pageActionCxt = useContext(PageActionContext);

    const handleChange = useCallback((data) => {
        console.log(data);
        setOption(data);
    });

    useEffect(() => {
        pageActionCxt.setNextDisabled(!option);
    }, [option]);

    useEffect(() => {
        if (pageActionCxt.isNextClicked) {
            var nextUrlData = option.data?.nextUrl;
            if (nextUrlData) {
                pageActionCxt.navigate(
                    nextUrlData.value,
                    nextUrlData.isExternal
                );
            }
            pageActionCxt.setNextClicked(false);
        }
    }, [pageActionCxt.isNextClicked]);

    return <OptionsBoxRadio data={data.optionsVm} onChange={handleChange} />;
};

export default FormConfirmationChoice;
